import axios from 'axios'
import qs from 'qs'

const client = axios.create({
  baseURL: '/api',
  paramsSerializer: (query) => qs.stringify(query)
})

export default {
  client,

  get(path, req) {
    return this.respond(client.get(path, req));
  },

  post(path, req) {
    return this.respond(client.post(path, req));
  },

  patch(path, req) {
    return this.respond(client.patch(path, req));
  },

  delete(path, req) {
    return this.respond(client.delete(path, req));
  },

  respond(request) {
    return new Promise((resolve, reject) => {
      return request
        .then(res => resolve(res.data, res))
        .catch(err => reject(err, err.response.data))
    })
  }

}